import React from "react";
import ReturnCartPage from "./ReturnCartPage";
import V2RouteShell from "../V2RouteShell";

function ReturnCartV2(props) {
  return (
    <V2RouteShell>
      <ReturnCartPage {...props} />
    </V2RouteShell>
  );
}

export default ReturnCartV2;
